import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconCopySvg } from "./IconCopySvg.mjs";
const IconCopy = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconCopySvg, ...iconProps });
};
export {
  IconCopy
};
